/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-08-13
 */

import {
  DashboardProjectAnalyticsQuery,
  DashboardProjectAnalyticsResult,
} from "../features/dashboard/model/types";
import { getProjectWiseAnalyticsApi } from "./dashboardApi";

export const getDashboardProjectAnalytics = async (
  query: DashboardProjectAnalyticsQuery = {}
): Promise<DashboardProjectAnalyticsResult> => {
  const response = await getProjectWiseAnalyticsApi(query);

  const rows = Array.isArray(response.results)
    ? response.results
    : Array.isArray(response.data)
      ? response.data
      : [];

  const count = typeof response.count === "number" ? response.count : rows.length;

  return {
    count,
    rows,
  };
};
